export const COOKIE_ACCESS_TOKEN_KEY = 'hml_access_token'
